import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GenericService } from "app/_services/generic.service";
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from "environments/environment";
import { ActionsDetailsModel } from "./action-details.model";
import { SharedService } from "app/_services";

@Injectable({
    providedIn: 'root',
})


export class ActionService extends GenericService<ActionsDetailsModel>{

    constructor(private http: HttpClient, private sharedService: SharedService) {
        super(http,'/DossierAction/',environment.Services.AlphaURLSlot3)
    }

    getByStatus(status:string, assignee: string,fromDate = null,toDate =null, state): Observable<any> {
        const query = this.sharedService.formatObjectToQueryString({fromDate,toDate,assignee});
        const URI = `/GetByStatus/${status}?${query}`;
     
        return this._http.post(this.url +URI,state ? state : {},
         this.prepareHeader()).pipe(map(res => res as any))
    }

    public getActionsStatusCount ({fromDate,toDate}) : Observable<any> {
        const query = this.sharedService.formatObjectToQueryString({fromDate,toDate});

        return this._http.get(this.url +"/GetCountActionsPerStatus?"+ query, this.prepareHeader()).pipe(map(res => res as AnalyserNode))
    }

    public getStatsIntake (dataRequest : any) : Observable<any> {
        return this._http.get(this.url +"/GetStatsIntake/"+ dataRequest, this.prepareHeader()).pipe(map(res => res as AnalyserNode))
    }

    public getContributionsHV (dataRequest : any) : Observable<any> {
        return this._http.get(this.url +"/GetContibutionsHV/"+ dataRequest, this.prepareHeader()).pipe(map(res => res as AnalyserNode))
    }

    public getActionsNotes (dataRequest : any) : Observable<any> {
        return this._http.get(this.url +"/GetActionsNotes/"+ dataRequest, this.prepareHeader()).pipe(map(res => res as any))
    }

    public getActionsByDossierId (dossierId : string) : Observable<ActionsDetailsModel[]> {
        console.log(this.url);
        return this._http.get(this.url +"V2/getByDossierId/"+ dossierId, this.prepareHeader()).pipe(map(res => res as ActionsDetailsModel[]))
    }

    public getActionsByWorkingOrderId (workingOrderId : string) : Observable<ActionsDetailsModel[]> {
        return this._http.get(this.url +"/getByWorkingOrderId/"+ workingOrderId, this.prepareHeader()).pipe(map(res => res as ActionsDetailsModel[]))
    }

    public addUpdateDossierAction (dossierActions : any []) : Observable<ActionsDetailsModel[]> {
        return this._http.post(this.url +"/addUpdateDossierActions", dossierActions, this.prepareHeader()).pipe(map(res => res as any));
    }

    public setAutomaticActions (dossierActions : any []) : Observable<ActionsDetailsModel[]> {
        return this._http.post(this.url +"/setAutomaticActions", dossierActions, this.prepareHeader()).pipe(map(res => res as any));
    }

    public updateInsuranceAction (organisationPolicy : any) : Observable<any> {
        return this._http.put(this.url +"/updateInsuranceAction", organisationPolicy, this.prepareHeader()).pipe(map(res => res as any));
    }

    public getDailyMessages () : Observable<any> {
        return this._http.get(this.url +"/getDailyMessages", this.prepareHeader()).pipe(map(res => res as any));
    }

    public getWeeklyMessages () : Observable<any> {
        return this._http.get(this.url +"/getWeeklyMessages", this.prepareHeader()).pipe(map(res => res as any));
    }

    public getActions () : Observable<any> {
        return this._http.get(this.url +"/GetActionList", this.prepareHeader()).pipe(map(res => res as any));
    }   
    
    public updateAssigneeAndStatus (action) : Observable<any> {
        return this._http.put(this.url +"/UpdateAssigneeAndStatus", action, this.prepareHeader()).pipe(map(res => res as any));
    }
    
    public getPendingActions (email) : Observable<any> {
        return this._http.get(this.url +"/GetPendingActions", this.prepareHeader()).pipe(map(res => res as any));
    } 

    public getCompletedActions (email) : Observable<any> {
        return this._http.get(this.url +"/GetCompletedActions", this.prepareHeader()).pipe(map(res => res as any));
    } 
    
}